import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';

import { NbThemeModule, NbIconModule, NbIconLibraries } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimations(),

    importProvidersFrom(
      NbThemeModule.forRoot({ name: 'dark' }),
      NbIconModule,
      NbEvaIconsModule
    ),
    {
      provide: 'icon-pack-init',
      useFactory: () => {
        const iconLib = inject(NbIconLibraries);
        iconLib.setDefaultPack('eva');
        return true;
      },
    },
  ]
};
